import React, { useState } from 'react';
import { applyTypography, BaseButton, useT } from '@repo/common';

/**
 * 환불 거절 확인 + 사유 입력. 공용 Modal 은 본문에 입력란을 넣을 수 없어 따로 둔다.
 * 사유는 유저 안내 메일과 어드민 목록(Refund rejected 행)에 남는다.
 */
const RejectRefundModal = ({
  isOpen,
  onClose,
  onConfirm,
  loading = false,
  summary,
}) => {
  const t = useT();
  const [reason, setReason] = useState('');

  if (!isOpen) return null;

  return (
    <>
      <div
        className='fixed inset-0 bg-surface-black40 z-[10000000000]'
        onClick={() => !loading && onClose?.()}
      />
      <div className='fixed inset-0 z-[10000000001] flex items-center justify-center px-[16px] py-[24px]'>
        <div
          role='dialog'
          aria-modal='true'
          className='bg-grayscale-gray00 w-full max-w-[520px] max-h-full overflow-y-auto rounded-[20px] p-[24px] tabletH:p-[32px] flex flex-col gap-[16px] shadow-2'
          onClick={(e) => e.stopPropagation()}
        >
          <div className='flex flex-col gap-[8px]'>
            <p className={`${applyTypography('title3')} text-text-primary`}>
              {t('Reject this refund request?', '이 환불 요청을 거절할까요?')}
            </p>
            {summary && (
              <p
                className={`${applyTypography('b14')} text-text-secondary`}
                style={{ lineHeight: 1.6 }}
              >
                {summary}
              </p>
            )}
            <p
              className={`${applyTypography('b14')} text-text-secondary`}
              style={{ lineHeight: 1.6 }}
            >
              {t(
                'The booking goes back to Confirmed and the seat is taken again. The guest gets an email saying the request was not approved, including the note below.',
                '예약은 다시 Confirmed 로 돌아가고 좌석도 다시 잡힙니다. 게스트에게는 아래 메모가 포함된 안내 메일이 발송됩니다.',
              )}
            </p>
          </div>

          <label className='flex flex-col gap-[6px]'>
            <span className={`${applyTypography('b13Strong')} text-text-secondary`}>
              {t('Note to guest (optional)', '게스트에게 전할 메모 (선택)')}
            </span>
            <textarea
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={3}
              maxLength={500}
              disabled={loading}
              placeholder={t(
                'e.g. The request was made less than 2 days before the event.',
                '예: 행사 2일 이내에 요청되어 정책상 환불이 어렵습니다.',
              )}
              className='w-full rounded-[8px] border border-grayscale-gray02 bg-grayscale-gray00 px-[12px] py-[10px] typo-b14 text-text-primary placeholder:text-text-placeholder focus:outline-none focus:border-grayscale-gray04 resize-y'
            />
          </label>

          <div className='flex gap-[8px] justify-end'>
            <BaseButton
              type='text_basic'
              size='m'
              hideIcon
              onClick={onClose}
              isDisabled={loading}
            >
              {t('Keep request', '유지')}
            </BaseButton>
            <BaseButton
              type='primary'
              size='m'
              hideIcon
              onClick={() => onConfirm?.(reason.trim())}
              isLoading={loading}
              isDisabled={loading}
              bgclass='bg-functional-failed03'
            >
              {t('Reject refund', '환불 거절')}
            </BaseButton>
          </div>
        </div>
      </div>
    </>
  );
};

export default RejectRefundModal;
